<template>
    <my-tag :type="item.type" @click="item.click" class="sh-state">{{item.text}}</my-tag>
</template>

<script>
import STATE_CONF from '../config/fkfs'

export default {
    components: {},
    props: {
        row: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        STATE_CONF
    }),
    computed: {
        item() {
            return this.STATE_CONF.filter(item => {
                return item.show(this.row);
            }).map(item => ({
                type: item.type,
                text: getType(item.text) === 'function' ? item.text(this.row) : item.text,
                click: getType(item.click) === 'function' ? item.click.bind(this) : () => {}
            }))[0] || {
                type: 'info',
                text: '无',
                click: ()=>{}
            };
        }
    },
    methods: {
        
    }
}
</script>

<style scoped lang="scss">
.sh-state{cursor:pointer;}
</style>
